import video1 from "../assets/img/video/v1.jpg";
import video2 from "../assets/img/video/v2.jpg";
import video3 from "../assets/img/video/v3.jpg";
import video5 from "../assets/img/video/v5.jpg";
import video6 from "../assets/img/video/v6.jpg";
import video7 from "../assets/img/video/v7.jpg";
import video8 from "../assets/img/video/v8.jpg";

const video = [
  {
    title: "video_1_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1522817609051658%2F&show_text=false&width=267&t=0",
    thumbnail: video8,
  },
  {
    title: "video_2_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1169508955060439%2F&show_text=false&width=267&t=0",
    thumbnail: video1,
  },
  {
    title: "video_3_title",
    link: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2552386218467539%2F&show_text=false&width=560&t=0",
    thumbnail: video2,
  },
  {
    title: "video_4_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F23955276994081567%2F&show_text=false&width=267&t=0",
    thumbnail: video3,
  },
  {
    title: "video_5_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F3022217447958710%2F&show_text=false&width=267&t=0",
    thumbnail: video5,
  },
  {
    title: "video_6_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1100168428639977%2F&show_text=false&width=267&t=0",
    thumbnail: video6,
  },
  {
    title: "video_7_title",
    link: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FManticCup%2Fvideos%2F2202736246807367%2F&show_text=false&width=267&t=0",
    thumbnail: video7,
  },
];

export { video };
